export default "__VITE_ASSET__DD4Bt2Pm__"